import { FC, useCallback, useContext, useEffect, useState } from 'react';

import { Button, Dropdown, Form, Spin, type MenuProps } from 'antd';
import { LoadingOutlined, MoreOutlined } from '@ant-design/icons';

import { QuotationInfoContext } from '../../../../../../../shared/contexts';
import { StepTwoFormContext } from '../../../../contexts/StepTwoForm';

import { QuotationStep } from '../../../../../../../shared/interfaces';
import { WizardDataFormContext } from '../../../../../../Wizard/contexts/WizardDataForm';

interface HeaderTabCardProps {
  id: number;
}

const TAB_OPTIONS = {
  DUPLICAR: '1',
  ELIMINAR: '2',
};

export const HeaderTabCar: FC<HeaderTabCardProps> = ({ id }) => {
  const { currentStep } = useContext(QuotationInfoContext);
  const { stepTwoForm } = useContext(WizardDataFormContext);

  const {
    duplicateTab,
    setKeyTabToDelete,
    setShowModal,
    tabs,
    generateTitleForTabs,
  } = useContext(StepTwoFormContext);

  const [title, setTitle] = useState<string>('');

  const brandFieldName = `brand-tab-${id}`;
  const brandSelected = Form.useWatch(brandFieldName, stepTwoForm);

  const modelFieldName = `model-tab-${id}`;
  const modelSelected = Form.useWatch(modelFieldName, stepTwoForm);

  const yearFieldName = `vehicleYear-tab-${id}`;
  const yearSelected = Form.useWatch(yearFieldName, stepTwoForm);

  const generateLabelDescription = useCallback(
    () =>
      setTitle(
        generateTitleForTabs(yearSelected, brandSelected, modelSelected) ?? ''
      ),
    [setTitle, generateTitleForTabs, yearSelected, brandSelected, modelSelected]
  );

  useEffect(() => {
    generateLabelDescription();
  }, [generateLabelDescription]);

  const items = [
    {
      key: TAB_OPTIONS.DUPLICAR,
      label: 'Duplicar',
    },
    {
      key: TAB_OPTIONS.ELIMINAR,
      label: 'Eliminar',
      danger: true,
      disabled: tabs.length === 1,
    },
  ];

  const onMenuClick: MenuProps['onClick'] = useCallback(
    async (e: { key: string }) => {
      if (e.key === TAB_OPTIONS.DUPLICAR) duplicateTab(id);

      if (e.key === TAB_OPTIONS.ELIMINAR) {
        setKeyTabToDelete(id);
        setShowModal(true);
      }
    },
    [setKeyTabToDelete, setShowModal, id, duplicateTab]
  );

  return (
    <>
      {tabs.length > 1 ? (
        title.length ? (
          title
        ) : (
          <Spin spinning indicator={<LoadingOutlined />} />
        )
      ) : (
        `Automóvil ${id}`
      )}

      {currentStep === QuotationStep.TWO && (
        <Dropdown
          menu={{ items, onClick: onMenuClick }}
          trigger={['click']}
          arrow
        >
          <Button type='text' style={{ padding: 0, marginLeft: 10 }}>
            <MoreOutlined />
          </Button>
        </Dropdown>
      )}
    </>
  );
};
